import { useState, type FormEvent } from "react";
import { useAuth } from "../contexts/AuthContext";
import { ApiError } from "../api/client";
import { approveDeviceCode } from "../api/auth";

export function DeviceApprovePage() {
  const { api } = useAuth();
  const [code, setCode] = useState("");
  const [label, setLabel] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [ok, setOk] = useState<string | null>(null);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true); setError(null); setOk(null);
    try {
      const r = await approveDeviceCode(api, code, label || undefined);
      setOk(`Approved "${r.device_label}". Return to your TV — it will finish signing in within a few seconds.`);
      setCode("");
      setLabel("");
    } catch (e) {
      setError(e instanceof ApiError ? e.message : "approve failed");
    } finally { setBusy(false); }
  }

  return (
    <form className="card" onSubmit={submit}>
      <h1>Approve a TV sign-in</h1>
      <p className="meta">Enter the code shown on your TV. This will sign that device in as you.</p>
      <div className="field">
        <label htmlFor="code">Code</label>
        <input id="code" type="text" autoCapitalize="characters" autoComplete="off" placeholder="WHJK-7T9P"
          value={code} required onChange={(e) => setCode(e.target.value)} />
      </div>
      <div className="field">
        <label htmlFor="label">Device name (optional)</label>
        <input id="label" type="text" placeholder="Living Room Fire TV"
          value={label} onChange={(e) => setLabel(e.target.value)} />
      </div>
      {error && <div className="error">{error}</div>}
      {ok && <div className="ok">{ok}</div>}
      <button className="btn primary" type="submit" disabled={busy || code.length < 8}>
        {busy ? "Approving…" : "Approve"}
      </button>
    </form>
  );
}
